
import * as vClickOutside from "v-click-outside";
/* eslint-disable */
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    listName: {
      type: String,
      default: "options",
    },
    value: {
      type: [String, Number],
      default: null,
    },
    tryForFree: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    associates: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropdownOpen: false,
      activeTooltip: null,
      options: [
        {
          name: "name",
          label: "Naziv opcije",
          type: "text",
        },
        {
          name: "id",
          label: "id",
          type: "text",
        },
        {
          name: "tooltip",
          label: "Tooltip za try for free associates",
          type: "tipTap",
        },
      ],
    };
  },
  computed: {
    vModel: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  watch: {
    value() {
      this.dropdownOpen = false;
    },
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
  },
};
